import { render, staticRenderFns } from "./pagenation.vue?vue&type=template&id=21e1dc09&scoped=true"
import script from "./pagenation.vue?vue&type=script&lang=js"
export * from "./pagenation.vue?vue&type=script&lang=js"
import style0 from "./pagenation.vue?vue&type=style&index=0&id=21e1dc09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e1dc09",
  null
  
)

export default component.exports